/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
// import { apiUrl } from "./constants";
import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  getIdTokenResult,
  signOut,
} from "firebase/auth";
import { authObj } from "./firebaseConfig";
import { goToLogin } from "./utils";

const authProvider = {
  login: (params) => {
    const { username, password } = params;
    return new Promise((resolve, reject) =>
      signInWithEmailAndPassword(authObj, username, password)
        .then(async ({ user }) => {
          const to = await getIdTokenResult(user, true).then((t) => t);
          const access = to?.claims?.access;
          if (!access) {
            await signOut(authObj);
            return reject(new Error("Unauthorized"));
          }
          return resolve();
        })
        .catch((error) => reject(error.message))
    );
  },

  logout: () =>
    new Promise((resolve) =>
      signOut(authObj).then(() => {
        localStorage.clear();
        goToLogin();
        return resolve();
      })
    ),

  checkError: (error) => {
    if (error?.status === 401) {
      return new Promise((resolve, reject) =>
        signOut(authObj).then(() => {
          localStorage.clear();
          goToLogin();
          return reject();
        })
      );
    }
    return Promise.resolve();
  },

  checkAuth: async () =>
    new Promise((resolve, reject) => {
      onAuthStateChanged(authObj, (user) => {
        if (user) {
          return resolve();
        }
        goToLogin();
        return reject();
      });
    }),

  getPermissions: async () =>
    new Promise((resolve, reject) => {
      onAuthStateChanged(authObj, async (user) => {
        if (user) {
          const to = await getIdTokenResult(user, true).then((t) => t);
          const access = to?.claims?.access || [];
          return resolve(access);
        }
        return reject();
      });
    }),
};

export default authProvider;
